import styled from 'styled-components';
import { Input, Button } from 'antd';

export const Container = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: row;
  width: 748px;
  height: 435px;
  padding: 24px;
  overflow: visible;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 32px 48px 0 rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(7px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);

  color: #333; /* opcional */
  font-weight: 700;
  font-size: 14px;
  line-height: 1.1;
  opacity: 1;
`;

export const LadoEsquerdo = styled.div`
  width: 299.19px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* IMPORTANTE: removi o justify-content: center para alinhar ao topo */
  justify-content: flex-start;
  padding: 0 20px;
  border-right: 1px solid #ccc;
`;

export const LadoDireito = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
  box-sizing: border-box;
`;

export const DetalheSuperiorDireito = styled.div`
  position: absolute;
  top: calc(48% - 250px);
  right: calc(48% - 400px);
  z-index: 1;
  width: 120px;
  height: 120px;
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(7px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const DetalheInferiorEsquerdo = styled.div`
  position: absolute;
  bottom: calc(47% - 250px);
  left: calc(47% - 400px);
  z-index: 1;
  width: 180px;
  height: 180px;
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(7px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const ContainerLogo = styled.div`
  position: relative;
  width: 100%;
  margin-top: 56px; /* Desloca 56px para baixo */
  text-align: center;
`;

export const Logo = styled.img`
  display: block;
  max-width: 220px;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
  border-radius: 0;
  opacity: 1;
  margin-top: 40px;
`;

export const CustomInput = styled(Input)`
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
`;

export const CustomPasswordInput = styled(Input.Password)`
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
`;

export const CustomButton = styled(Button)`
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
`;